export default "https://cdn-static-unstable.gokick.com/assets/b4100b98dde63e1c7260221a4305ac191c7ac51c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";